import apiService from './api.service';

export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  status: 'active' | 'inactive' | 'suspended' | 'invited';
  last_login_at?: string;
  created_at: string;
  updated_at: string;
  roles: Array<{
    id: string;
    name: string;
  }>;
}

export interface CreateUserRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleIds?: string[];
}

export interface UpdateUserRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  status?: 'active' | 'inactive' | 'suspended';
  roleIds?: string[];
}

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  avatarUrl?: string | null;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface InviteUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  roleIds?: string[];
}

class UserApi {
  async getAll(): Promise<{ success: boolean; data: User[] }> {
    return apiService.get('/v1/users');
  }

  async getById(id: string): Promise<{ success: boolean; data: User }> {
    return apiService.get(`/v1/users/${id}`);
  }

  async create(data: CreateUserRequest): Promise<{ success: boolean; data: User }> {
    return apiService.post('/v1/users', data);
  }

  async update(id: string, data: UpdateUserRequest): Promise<{ success: boolean; data: User }> {
    return apiService.put(`/v1/users/${id}`, data);
  }

  async delete(id: string): Promise<{ success: boolean; message: string }> {
    return apiService.delete(`/v1/users/${id}`);
  }

  async updateProfile(data: UpdateProfileRequest): Promise<{ success: boolean; data: User }> {
    return apiService.put('/v1/users/profile', data);
  }

  async changePassword(data: ChangePasswordRequest): Promise<{ success: boolean; message: string }> {
    return apiService.post('/v1/users/change-password', data);
  }

  async invite(data: InviteUserRequest): Promise<{ success: boolean; data: User; message: string }> {
    return apiService.post('/v1/users/invite', data);
  }

  async resendInvite(userId: string): Promise<{ success: boolean; message: string }> {
    return apiService.post(`/v1/users/${userId}/resend-invite`, {});
  }

  async assignApplications(userId: string, applicationIds: string[]): Promise<{ success: boolean; message: string }> {
    return apiService.post(`/v1/users/${userId}/applications`, { applicationIds });
  }

  async getUserApplications(userId: string): Promise<{ success: boolean; data: any[] }> {
    return apiService.get(`/v1/users/${userId}/applications`);
  }

  async removeApplication(userId: string, applicationId: string): Promise<{ success: boolean; message: string }> {
    return apiService.delete(`/v1/users/${userId}/applications/${applicationId}`);
  }
}

export default new UserApi();
